import React from "react";
import { edit_icon } from "../../../icons/edit";
import { Link } from "react-router-dom";
import { useAuth } from "../../../store/authProvider";
import { EmptyStarIcon, FullStarIcon } from "../../../icons/star";

function InputItem({ item, getInput, editLink, type, favoriteInputs }) {
  const { isAuth } = useAuth();

  return (
    <div
      className="relative flex flex-col items-center overflow-hidden w-full hover:scale-105 transition cursor-pointer  bg-white border-2 border-primary rounded-2xl  h-auto lg:w-auto lg:h-auto min-w-full lg:text-2xl"
      key={item.id}
      onClick={() => getInput(item.id)}
    >
      {isAuth && item.owner === localStorage.getItem("user_id") && (
        <Link to={editLink}>
          <div className="absolute right-0 text-gray-400 p-2">{edit_icon}</div>
        </Link>
      )}
      <img
        src={item?.input_category?.image}
        className=" h-[8rem] mt-2 scale-90 "
        alt=""
      />
      <div className="flex row items-center" dir="rtl">
        <div className="font-bold text-lg my-1">
          {item?.input_category?.name}
        </div>
      </div>
      <div className="text-lg max-w-[90%] italic max-h-[2rem] text-center truncate overflow-hidden whitespace-nowrap">

        {item?.name}
      </div>
      <div className="text-lg mb-0">
      {`السعر : ${item.price??"غير متوفر"}`}
      </div>
        <div className="text-lg mt-1">{item?._state?.name}</div>
      <div className="flex lg:flex-row flex-row items-center justify-between gap-3  align-baseline">

        <div className="flex flex-row items-center space-x-3 my-1">
          <div className="text-sm text-gray-400">
            قبل{" "}
            {Math.ceil(
              (new Date().getTime() - new Date(item?.created_at).getTime()) /
                86400000
            )}{" "}
            يوم
          </div>
          <div className=" text-primary">
            {favoriteInputs?.map((e) => e.id).includes(item.id)
              ? FullStarIcon
              : EmptyStarIcon}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InputItem;
